import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { hydrateStart } from "@tanstack/react-start/client";

// Client entry (TanStack Start picks up src/client.tsx in place of its
// default). The default entry renders <StartClient>, which suspends on the
// router's hydration promise, so React commits an empty shell first and
// hydrates the page only after its Suspense retry throttle (~300 ms). The
// Mediavine script in <head> inserts ads into #mv-content and the footer in
// that window, and React then fails hydration (error #418) and re-renders
// the page, dropping the ads. Waiting for the router here and hydrating
// afterwards hydrates the whole page in one pass, with nothing suspended.
hydrateStart().then((router) => {
  hydrateRoot(
    document,
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
});
